import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Button, Container, FloatingLabel, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App';
import Birthday from '../domain/Birthday.ts';
import Email from '../domain/Email';
import Password from '../domain/Password';
import ApiFetch from './ApiFetch';
import Dialog from './Dialog';
import Footer from './Footer';
import Header from './Header';
import OnetimePassword from '../domain/OnetimePassword';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import { useTranslation } from "react-i18next";

const TemporaryPassword = (props) => {
    async function oneTimePasswordSend(email){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/onetime/temporary_password",{email:email})
            .then((r)=>r.json().then((json)=>{
                if(json.result){
                    dialog("確認","ワンタイムパスワードをメールアドレス宛に送信しました。届いた番号を入力してください。")
                    setOneTimePasswordSended(true)
                } else {
                    dialog("エラー",json.errors)
                    setOneTimePasswordSended(false)
                }
            return json.result
        }))
    }
    async function resetPassword(email,birthday,onetimePassword,dialog){
        let emailObj = new Email(email)
        let birthdayObj = new Birthday(birthday)
        let onetimePasswordObj = new OnetimePassword(onetimePassword)
        // 必須・文字数・パターン
        if(!emailObj.validate(dialog) || !birthdayObj.validate(dialog) || !onetimePasswordObj.validate(dialog)){
            return false
        }
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/password/temporary",{email:emailObj.props,birthday:birthdayObj.props,onetimePassword:onetimePasswordObj.props}).then((r)=>{
            return r.json().then((json)=>{
                if(json.result){
                    dialog("確認","仮パスワードを発行しました。仮パスワードは" + json.data.temporary_password + "です")
                    document.getElementById("email").value = ""
                    document.getElementById("birthday").value = ""
                    document.getElementById("onetime-password").value = ""
                    setOneTimePasswordSended(false)
                } else {
                    dialog("エラー",json.errors)
                }
                return json.result
            })
        })
    }
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate();

    const [oneTimePasswordSended, setOneTimePasswordSended] = useState(false);

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 初期処理
    useEffect(() => {
        // タイトル設定
        document.querySelector("title").textContent = "仮パスワード発行 - ourt"
    },[])

    return (
    <div className="wrapper">
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <Container className='d-flex flex-row justify-content-center flex-wrap'>
                <Container className='mt-3 mb-3' style={{width:"360px"}}>
                    <h3>パスワード再発行</h3>
                    <p>再発行、再設定の流れ</p>
                    <ul style={{listStyleType:"decimal"}}>
                        <li>パスワードリセットメール送信</li>
                        <li>メールに記載のワンタイムパスワード入力</li>
                        <li>仮パスワード発行</li>
                        <li>仮パスワードでログインして「設定」の「パスワード再設定」からパスワードの再設定を行う</li>
                    </ul>
                    <FloatingLabel controlId="email" label="ログインに使用しているメールアドレス" className="mb-3">
                        <Form.Control type="email" placeholder="" />
                    </FloatingLabel>
                    <FloatingLabel controlId="birthday" label="誕生日" className="mb-3">
                        <Form.Control type="date" />
                    </FloatingLabel>
                    <Button onClick={() => {
                        if(new Email(document.getElementById("email").value).validate(dialog,true)
                            && new Birthday(document.getElementById("birthday").value).validate(dialog,true)){
                            oneTimePasswordSend(document.getElementById("email").value)
                        }
                    }} className="mb-1">パスワードリセットメール送信</Button>
                    <div className="mb-3">メールアドレス宛にワンタイムパスワードを送信します。</div>
                    <FloatingLabel controlId="onetime-password" label="ワンタイムパスワード" style={{display:oneTimePasswordSended ? "block" : "none"}}>
                        <Form.Control type="number" cows="10" />
                    </FloatingLabel>
                    <Button onClick={() => {
                        resetPassword(
                            document.getElementById("email").value,
                            document.getElementById("birthday").value,
                            document.getElementById("onetime-password").value,
                            dialog
                        )
                    }} className="mt-3">仮パスワード発行</Button>
                </Container>

        </Container>
        <Footer />
    </div>
    )
}

export default TemporaryPassword;
